import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c43a9400"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg-white p-7 lg:ml-7 self-stretch min-w-[300px] w-full lg:w-[30%] 2xl:w-[40%] text-left 2xl:text-center" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "font-semibold text-3xl mb-7" }, "Occupancy Summary", -1))
const _hoisted_3 = { class: "mb-3" }
const _hoisted_4 = {
  key: 0,
  class: "h-[23px] w-full rounded-sm bg-gray-200 my-6 animate-pulse2"
}
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h-[210px] w-full rounded-sm bg-gray-200 mb-8 animate-pulse2" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h-[23px] w-full rounded-sm bg-gray-200 mb-6 animate-pulse2" }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h-[23px] w-full rounded-sm bg-gray-200 animate-pulse2" }, null, -1))
const _hoisted_10 = [
  _hoisted_7,
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "chartBox flex items-center justify-center" }, [
  /*#__PURE__*/_createElementVNode("canvas", {
    id: "doughnut-chart",
    width: "400",
    height: "400"
  })
], -1))
const _hoisted_12 = [
  _hoisted_11
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass({ '2xl:my-[100px]': !_ctx.isLoading })
    }, [
      _hoisted_2,
      _createElementVNode("p", _hoisted_3, [
        (_ctx.isLoading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4))
          : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.selectedLocation.name), 1))
      ]),
      (_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_10))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass(["flex h-full items-center justify-center", { hidden: _ctx.isLoading }])
      }, _hoisted_12, 2)
    ], 2)
  ]))
}